import { render } from "./SecUsadosHP.vue?vue&type=template&id=46ce3840"
import script from "./SecUsadosHP.vue?vue&type=script&lang=js"
export * from "./SecUsadosHP.vue?vue&type=script&lang=js"

import "./SecUsadosHP.vue?vue&type=style&index=0&id=46ce3840&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__